import { httpPost } from '../../../../components/utils';
import { showAlert } from '@silverfort/sf-components';
import { isAxiosError } from '../../../../core/api/client/secureAxios';
import { HTTP_RES_STATUS_CODES } from '@silverfort-nodelibs/common/utils/consts';
import { useCallback } from 'react';

export const useUpdateAppsFromCsv = () => {
    const reqUrl = `/accessAnalysis/uploadAppsData`;

    const handleAlert = (response) => {
        const hasFailedItems = response.some(({ result }) => !result);
        const succeededItems = response.filter(({ result }) => result);

        if (hasFailedItems) {
            showAlert(`Managed to upload ${succeededItems.length} out of ${response.length} applications.`, 'info');
        } else {
            showAlert(`Successfully uploaded ${response.length} applications.`, 'success');
        }
    };

    const updateAppsFromCsvMutation = useCallback(async (fileData) => {
        try {
            const { data } = await httpPost(reqUrl, fileData);

            handleAlert(data);
        } catch (err) {
            if (isAxiosError(err)) {
                const httpError = err.response;

                if (httpError.status === HTTP_RES_STATUS_CODES.BAD_REQUEST) {
                    const { error } = httpError.data;
                    const badRequestReason = error.toLowerCase() || 'corrupted file.';

                    showAlert(`Failed to upload applications due to ${badRequestReason}`, 'error');
                }
            } else {
                showAlert('Failed to upload applications. Please contact support.', 'error');
            }
        }
    }, []);

    return { updateAppsFromCsvMutation };
};
